import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { FlexColumn } from '../../../components/atoms/layout/Flex'
import VisitorRegistrationForm from '../../../components/organisms/visitor/registration/Form'
import { CompanyActions } from '../../../store/company'
import { CompanySelectors } from '../../../store/company/selectors'
import Alert from '../../../components/atoms/feedback/Alert'

export default function VisitorRegistrationAnswersPage() {
  const dispatch = useDispatch()
  const form = useSelector(CompanySelectors.visitorRegistrationForm)

  useEffect(() => {
    dispatch(CompanyActions.fetchVisitorRegistrationForm())
  }, [dispatch])

  if (!form) {
    return (
      <FlexColumn>
        <Alert severity="error">事業者情報を設定してください</Alert>
      </FlexColumn>
    )
  }
  return (
    <FlexColumn>
      <Alert severity="error" title="回答内容に変更があった場合は必ず変更をしてください">
        変更がないままトラブルがあった場合は弊社では責任は一切負いかねます
      </Alert>
      <VisitorRegistrationForm form={form} />
    </FlexColumn>
  )
}
